import { CircularProgress, Stack } from "@mui/material";

import React from "react";

export const ProcessingIcon = () => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{ backgroundColor: "primary.main", borderRadius: "1000px", height: "60px", width: "60px" }}
  >
    <CircularProgress sx={{ color: "#FFF" }} />
  </Stack>
);
